// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/Content/IdeasLab/EditorField.js
import React from 'react';
import LexicalEditor from '../LexicalEditor'; // ปรับ path ตามโครงสร้างจริง

const EditorField = ({ fieldName, label, placeholder, onChange, onImageUpload, isUploading, setIsUploading, initialValue }) => {
  return (
    <LexicalEditor
      fieldName={fieldName}
      label={label}
      placeholder={placeholder}
      onChange={onChange}
      onImageUpload={onImageUpload}
      isUploading={isUploading}
      setIsUploading={setIsUploading}
      initialValue={initialValue}
    />
  );
};

export default EditorField;